import {
  STAFF_MOVEMENT_PLATFORMS_ALL,
  STAFF_MOVEMENT_PLATFORM_OPTIONS,
} from '../shared/models/new-roster.model';

// Splits a stored value ('All' or CSV such as 'android,ios') into normalized platform keys.
export function parseStaffMovementPlatforms(platforms: string | null | undefined): string[] {
  if (!platforms) return [];
  return platforms
    .split(',')
    .map((p) => p.trim().toLowerCase())
    .filter((p) => !!p);
}

export function isAllStaffMovementPlatforms(platforms: string | null | undefined): boolean {
  return !platforms || platforms.trim().toLowerCase() === STAFF_MOVEMENT_PLATFORMS_ALL.toLowerCase();
}

// Mirrors Constants.StaffMovementPlatforms.IsPlatformEnabled on the backend: null/empty/'All' enable every
// platform, and a platform that is not a supported mobile OS (e.g. 'web') is never filtered.
export function isStaffMovementEnabledForPlatform(
  platforms: string | null | undefined,
  platform: string
): boolean {
  if (isAllStaffMovementPlatforms(platforms)) return true;
  const key = (platform || '').trim().toLowerCase();
  if (!STAFF_MOVEMENT_PLATFORM_OPTIONS.some((o) => o.key === key)) return true;
  return parseStaffMovementPlatforms(platforms).includes(key);
}

// The mode that actually applies to this device: a platform that is switched off behaves like 'Off'.
export function resolveStaffMovementMode(
  mode: string | undefined,
  platforms: string | null | undefined,
  platform: string
): string | undefined {
  if (mode === 'Off') return mode;
  return isStaffMovementEnabledForPlatform(platforms, platform) ? mode : 'Off';
}
